import stem_dict from '../assets/stem_dict.json';
function swap(json){
  var ret = {};
  for(var key in json){
    ret[json[key]] = key;
  }
  return ret;
}
var reverse_stem_dict = swap(stem_dict);

function number_range (start, end) {
  return new Array(end - start).fill().map((d, i) => String(i + start));
}
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
function floats(n) {
  if (isNumeric(n)) {return parseFloat(n)} else {return 0};
}
function remove(array, element) {
    return array.filter(e => e !== element);
}

export default {
  methods: {
      chart_filter_m: function(stem = true) {
          // var dsets = [];
          // var colors = ['#e1002d', '#888b95', '#1473e1', '#e18214'];
          var comp_data = [];
          var slowo = '';
          var if_deleted_word = 1;
          // console.log(JSON.stringify(this.kw_filter));
          // console.log(this.kw_filter.length, this.kw_old.length)
          for (var i = 0; i < this.kw_search.length; i++) {
           // if (this.kw_filter.length > this.kw_old.length) 
              comp_data = Array.from(Array(25), () => 0);
              if (this.stem == true) { 
                slowo = stem_dict[this.kw_filter[i]['word']];
              }
              else {
                slowo = this.kw_filter[i]['word'];
              }
              // console.log(slowo, this.kw_filter[i]['word'], this.kw_old);
              if (this.kw_old.indexOf(slowo) > -1) {
                continue;
              }
              else {
                if_deleted_word = 0;
                this.kw_old.push(slowo);
              }
              // console.log('stringify', JSON.stringify(this.kw_filter[i]));
              var cols_kw = Object.keys(this.kw_filter[i]);
              var cols = Array()
              var col_name = ''
              // for (var j = 1; j <= cols_kw.length; j ++) {
              //   col_name = cols_kw[cols_kw.length-j];
              //   cols.push(col_name.substr(5,col_name.length));
              // }
              cols = this.cols;
              for (var j = 0; j < cols.length; j++) {
                // console.log(j,cols[j]);
                comp_data[j] = floats(this.kw_filter[i]['freq_' + cols[j]]);
              }
              // console.log(slowo, comp_data);
              this.dsets.push({
                label: slowo,
                backgroundColor: 'transparent',
                borderColor: this.colors.pop(),
                borderWidth: 3,
                data: comp_data
              });
              this.cols = cols;
              // console.log(cols);
              return {
                  labels: cols,
                  datasets: this.dsets,
              }
            }
            if (if_deleted_word == 1) {
              // console.log(this.kw_old, this.kw_search);
              for (var i = 0; i < this.kw_old.length; i++) {
                console.log('for ', i, this.kw_old[i], this.kw_search, this.kw_search.indexOf(this.kw_old[i]));
                if (this.stem == true) {
                 var kw_to_reverse = this.kw_search.indexOf(reverse_stem_dict[this.kw_old[i]]);
                }
                else {
                  var kw_to_reverse = this.kw_search.indexOf(this.kw_old[i]);
                }
                if (kw_to_reverse == -1) {
                  // console.log('to_delete', this.kw_old[i], this.kw_search);
                  var deleted_word = this.kw_old[i];
                  this.kw_old = remove(this.kw_old,this.kw_old[i]);
                  break;
                }
              }
              for (var i = 0; i < this.dsets.length; i++) {
                if (this.dsets[i]['label'] == deleted_word) {
                  // console.log(deleted_word);
                  if (this.dsets[i]['borderColor']) {this.colors.push(this.dsets[i]['borderColor']);
                }
                  this.dsets = remove(this.dsets, this.dsets[i]);
                }
              }
              return {
                  labels: this.cols,
                  datasets: this.dsets,
              }
            }
      }
    },
  }


// WEBPACK FOOTER //
// ./src/mixins/chart_filter_m_wiki_multilang.js